import AbstractCanvasTransformTool from "ui/canvas/transforms/AbstractCanvasTransformTool";
import {SCENE_FRAMES} from "ui/config";

export default class CanvasSharpen extends AbstractCanvasTransformTool {
	/**
	 * @param {number} [factor]
	 */
	constructor(factor) {
		super();

		/**
		 * @type {number}
		 * @private
		 */
		this._factor = factor;
	}

	/**
	 * @inheritDoc
	 */
	_isNeedKeyframesForSelection(fromFrame, toFrame) {
		return fromFrame !== toFrame && this._radiusFrom !== this._radiusTo;
	}

	/**
	 * @param {HTMLCanvasElement} canvas
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {HTMLImageElement} img
	 * @param {number} frameIndex
	 * @returns {?T_DataSetItem}
	 * @protected
	 */
	_processImage(canvas, ctx, img, frameIndex) {
		ctx.clearRect(0, 0, this._sceneWidth, this._sceneHeight);
		ctx.save();
		ctx.drawImage(img, 0, 0);
		this._sharpen(ctx, canvas.width, canvas.height);
		ctx.restore();
		
		return this._dataSet.setData(canvas.toDataURL('image/png'));
	}

	_sharpen(context, width, height) {
		let mix = this._factor;

		// create an empty element with the given width/height
		let dstData = context.createImageData(width, height);
		let dstBuff = new Uint32Array(dstData.data.buffer);

		// collection of information
		let pixel = context.getImageData(0, 0, width, height);

		let data = new Uint32Array(pixel.data.buffer);
		// Everything to work with the matrix
		let kernel = [
			[0, -1, 0], // matrixа
			[-1, 5, -1],
			[0, -1, 0]
		];
		let katet = Math.round(Math.sqrt(kernel.length)) + 1; //root 9=3
		let half = (katet * 0.5) | 0; //3*0.5=1.5 discard values after the decimal point

		// pixel processing
		let dstIndex = 0, red, green, blue;
		for (let y = 0; y < height; y++) {
			for (let x = 0; x < width; x++) {
				let r = 0, g = 0, b = 0;
				for (let sy = 0; sy < katet; sy++) {
					const yy = Math.min(height - 1, Math.max(0, y + sy - half));
					for (let sx = 0; sx < katet; sx++) {
						const xx = Math.min(width - 1, Math.max(0, x + sx - half));
						let pix = data[yy * width + xx];
						r += ((pix & 0xFF) * kernel[sy][sx]);
						g += ((((pix) >> 8) & 0xFF) * kernel[sy][sx]);
						b += ((((pix) >> 16) & 0xFF) * kernel[sy][sx]);
					}
				}
				red = Math.min(255, Math.max(0, (r * mix) + ((data[y * width + x]) & 0xFF) * (1 - mix))) & 0xFF;
				green = Math.min(255, Math.max(0, (g * mix) + (((data[y * width + x]) >> 8) & 0xFF) * (1 - mix))) & 0xFF;
				blue = Math.min(255, Math.max(0, (b * mix) + (((data[y * width + x]) >> 16) & 0xFF) * (1 - mix))) & 0xFF;
				const alfa = data[y * width + x] & 0xFF000000;

				dstBuff[dstIndex++] = red | ((green) << 8) | ((blue) << 16) | alfa | ((blue) << 16); // fill with changes
			}
		}
		context.putImageData(dstData, 0, 0);//overwriting the canvas with new data
	}
}
